export class Civilite {
    id: string;
    titre: string;
    code: string;
    
    constructor(){}
}
